export default __webpack_public_path__ + "static/media/Emojis09.3041bf5a.png";